import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { setupTooltip } from "../common/tooltip";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate({
		onCompleted: () => {
			localizeLinks();
			setupTooltip();
		},
	});

	//
	// Geo-location
	// ------------------------------------------------------------------------
	const userLocationSuccess = async (position) => {
		const lat = position.coords.latitude;
		const lng = position.coords.longitude;
		const { Geocoder } = await google.maps.importLibrary("geocoding");
		const { LatLng } = await google.maps.importLibrary("core");
		const { GeocoderStatus } = await google.maps.importLibrary("geocoding");
		const geocoder = new Geocoder();
		const latlng = new LatLng(lat, lng);
		geocoder.geocode({ latLng: latlng }, (results, status) => {
			if (status === GeocoderStatus.OK) {
				let currentCity = "";
				for (const rIndex in results) {
					if (currentCity !== "") {
						break;
					}
					for (const aIndex in results[rIndex].address_components) {
						if (currentCity !== "") {
							break;
						}
						const currentAddressComponent =
							results[rIndex].address_components[aIndex];
						if (currentAddressComponent.types.indexOf("locality") > -1) {
							// "administrative_area_level_2" for the province
							currentCity = currentAddressComponent.long_name;
						}
					}
				}

				if (currentCity === "") {
					console.warn(" --- No city was found using reverse geocoding");
					return;
				}

				fetch(`/cinema/localizza/?citta=${currentCity}`, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => response.json())
					.then((data) => {
						window.localStorage.setItem("localizedCity", currentCity);
						window.localStorage.setItem("localizedCitySlug", data.slug);
					})
					.catch(() => {
						console.warn(" --- Errors in retrieving the geolocalized city url");
					});
			} else {
				console.warn(` --- Geocoder failed due to: ${status}`);
			}
		});
	};

	const userLocationError = (err) => {
		console.warn(` --- Geo location error number ${err.code}: ${err.message}`);
		for (const el of document.querySelectorAll("._city_url")) {
			el.textContent = "Scopri in quali città guardarlo";
			addCityUrlEventListener(el);
			el.style.display = "inline";
		}
	};

	const addCityUrlEventListener = (element) => {
		element.addEventListener("click", (event) => {
			event.preventDefault();
			const cityLink = event.target;
			let url = `/cinema/programmazione/${cityLink.dataset.movie}/`;
			if (cityLink.dataset.city) {
				url = `${url}?citta=${cityLink.dataset.city}`;
			}
			fetch(url, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
			})
				.then((response) => response.text())
				.then((data) => {
					cityLink.style.display = "none";
					const container = document.querySelector(
						`#_movie-${cityLink.dataset.movie}`,
					);
					container.innerHTML = data;
					container.style.display = "block";
					container
						.querySelector("._showtimes_toggle")
						?.addEventListener("click", (ev) => {
							ev.preventDefault();
							const toggleButton = ev.target;
							if (toggleButton.textContent !== "Chiudi") {
								for (const el of container.querySelectorAll(
									"._hidden_showtimes",
								)) {
									el.style.display = "block";
									el.classList.remove("_hidden_showtimes");
								}
								toggleButton.textContent = "Chiudi";
							} else {
								container.style.display = "none";
								cityLink.style.display = "inline";
							}
						});
				})
				.catch((error) => {
					console.warn(error);
				});
		});
	};

	const localizeLinks = () => {
		const localCity = window.localStorage.getItem("localizedCity");
		const localCitySlug = window.localStorage.getItem("localizedCitySlug");
		for (const el of document.querySelectorAll("._city_url")) {
			if (localCity && localCitySlug) {
				el.dataset.city = localCitySlug;
				el.querySelector("._city_name").textContent = localCity;
			} else {
				el.textContent = "Scopri in quali città guardarlo";
			}
			addCityUrlEventListener(el);
			el.style.display = "inline";
		}
	};

	if (
		!window.localStorage.getItem("localizedCity") ||
		!window.localStorage.getItem("localizedCitySlug")
	) {
		navigator.geolocation.getCurrentPosition(
			userLocationSuccess,
			userLocationError,
		);
	} else {
		localizeLinks();
	}
	for (const el of document.querySelectorAll("._city_url_visible")) {
		addCityUrlEventListener(el);
	}
});
